export interface PelletsStateConfig {
  name: string;
  slug: string;
  heroImage?: string;
  heroImageAlt?: string;
  headline: string;
  howItWorksTitle: string;
  howItWorksDescription: string;
  howItWorksSecondary: string;
  defaultZipcode: string;
}

const pelletsStateContent: Record<string, PelletsStateConfig> = {
  "baden-wuerttemberg": {
    name: "Baden-Württemberg",
    slug: "baden-wuerttemberg",
    heroImage: require("~/assets/images/pellets/state/baden-wuerttenberg.webp"),
    heroImageAlt: "Holzpellets Baden-Württemberg",
    headline: "Aktuelle Pelletspreise für Baden-Württemberg",
    howItWorksTitle:
      "Pelletspreis Baden-Württemberg: Ihr regionaler Preisvergleich",
    howItWorksDescription:
      "Finden Sie den günstigsten Pelletspreis in Baden-Württemberg durch unseren smarten Vergleich. Mit nur wenigen Angaben wie gewünschte Liefermenge und Postleitzahl ermitteln Sie die attraktivsten Angebote von Pellethändlern in Ihrer Region. Unser System zeigt Ihnen transparent die aktuellen Marktpreise in Baden-Württemberg und hilft Ihnen, direkt beim Pelletkauf bares Geld einzusparen.",
    howItWorksSecondary:
      "Die Pelletpreise in Baden-Württemberg unterliegen kontinuierlichen Schwankungen und werden bei uns regelmäßig aktualisiert. So behalten Sie jederzeit den Überblick über die Preisentwicklung und können zum optimalen Zeitpunkt bestellen. Nutzen Sie unseren Vergleichsrechner und profitieren Sie vom besten Preis-Leistungs-Verhältnis bei renommierten Anbietern in Baden-Württemberg.",
    defaultZipcode: "70173",
  },
  bayern: {
    name: "Bayern",
    slug: "bayern",
    heroImage: require("~/assets/images/pellets/state/bayern.webp"),
    heroImageAlt: "Holzpellets Bayern",
    headline: "Aktuelle Pelletspreise für Bayern",
    howItWorksTitle: "Pelletspreis Bayern: Transparent vergleichen und sparen",
    howItWorksDescription:
      "Unser Pellets-Preisvergleich Bayern verschafft Ihnen einen klaren Marktüberblick. Geben Sie einfach Ihre Postleitzahl und die gewünschte Bestellmenge ein und wir zeigen Ihnen sofort die preiswertesten Pellethändler in Ihrer bayerischen Region. Der Vergleich ermöglicht es Ihnen, schnell und unkompliziert Geld beim Holzpelletskauf zu sparen.",
    howItWorksSecondary:
      "Wir aktualisieren die Pelletpreise in Bayern laufend, damit Sie stets die aktuellen Konditionen einsehen können. So treffen Sie fundierte Kaufentscheidungen und sichern sich faire Preise. Unser Service bringt Sie direkt zu den günstigsten Lieferanten in Bayern für eine kostengünstige und zuverlässige Pelletsversorgung.",
    defaultZipcode: "80331",
  },
  berlin: {
    name: "Berlin",
    slug: "berlin",
    heroImage: require("~/assets/images/pellets/state/berlin.webp"),
    heroImageAlt: "Holzpellets Berlin",
    headline: "Aktuelle Pelletspreise für Berlin",
    howItWorksTitle: "Pelletspreis Berlin: Die Hauptstadt im Preisvergleich",
    howItWorksDescription:
      "Vergleichen Sie jetzt den Pelletspreis in Berlin und entdecken Sie attraktive Angebote für Ihre Pelletheizung. Durch Eingabe Ihrer Postleitzahl und der benötigten Pelletmenge erhalten Sie eine übersichtliche Darstellung der Preise verschiedener Berliner Anbieter. So finden Sie mit wenigen Klicks die kostengünstigste Option für Ihren Pelletsbedarf in der Hauptstadt.",
    howItWorksSecondary:
      "Der Pelletmarkt in Berlin entwickelt sich dynamisch und unsere Plattform sorgt dafür, dass Sie immer die neuesten Preise im Blick haben. Dank regelmäßiger Aktualisierung können Sie gezielt zum besten Zeitpunkt zuschlagen. Profitieren Sie von unserem Vergleichsservice und sichern Sie sich top Konditionen beim Pelletskauf in Berlin.",
    defaultZipcode: "10115",
  },
  brandenburg: {
    name: "Brandenburg",
    slug: "brandenburg",
    heroImage: require("~/assets/images/pellets/state/brandenburg.webp"),
    heroImageAlt: "Holzpellets Brandenburg",
    headline: "Aktuelle Pelletspreise für Brandenburg",
    howItWorksTitle: "Pelletspreis Brandenburg: Regional clever einkaufen",
    howItWorksDescription:
      "Mit unserem Pelletspreis-Vergleich für Brandenburg finden Sie mühelos die vorteilhaftesten Angebote in Ihrer Umgebung. Nennen Sie uns Ihre Postleitzahl sowie die gewünschte Menge und wir präsentieren Ihnen die günstigsten Lieferanten im Land Brandenburg. Einfach, schnell und transparent kommen Sie so zu fairen Konditionen.",
    howItWorksSecondary:
      "Die Pelletpreise in Brandenburg ändern sich regelmäßig, daher sorgen wir für eine zeitnahe Aktualisierung der Marktdaten. Behalten Sie die Preisentwicklung im Auge und kaufen Sie zum optimalen Moment. Unser Preisvergleich hilft Ihnen, beim Holzpelletskauf spürbar zu sparen und dabei auf Qualität zu setzen.",
    defaultZipcode: "14467",
  },
  bremen: {
    name: "Bremen",
    slug: "bremen",
    heroImage: require("~/assets/images/pellets/state/bremen.webp"),
    heroImageAlt: "Holzpellets Bremen",
    headline: "Aktuelle Pelletspreise für Bremen",
    howItWorksTitle:
      "Pelletspreis Bremen: Kompakt und übersichtlich vergleichen",
    howItWorksDescription:
      "Nutzen Sie unseren Vergleichsservice für den Pelletspreis in Bremen und verschaffen Sie sich einen schnellen Marktüberblick. Mit der Angabe von Postleitzahl, Liefermenge und gewünschter Pelletqualität liefern wir Ihnen die besten verfügbaren Preise aus Bremen und Umgebung. So gelangen Sie direkt zu den wirtschaftlichsten Angeboten für Ihre Heizung.",
    howItWorksSecondary:
      "Wir halten die Pelletpreise für Bremen stets auf dem neuesten Stand, sodass Sie keine Preisschwankung verpassen. Bestellen Sie Ihre Pellets zum günstigsten Zeitpunkt. Dank unserem Service finden Sie rasch den passenden Lieferanten mit fairem Preis-Leistungs-Verhältnis in Bremen.",
    defaultZipcode: "27568",
  },
  hamburg: {
    name: "Hamburg",
    slug: "hamburg",
    heroImage: require("~/assets/images/pellets/state/hamburg.webp"),
    heroImageAlt: "Holzpellets Hamburg",
    headline: "Aktuelle Pelletspreise für Hamburg",
    howItWorksTitle: "Pelletspreis Hamburg: Ihr Tor zu günstigen Angeboten",
    howItWorksDescription:
      "Entdecken Sie den aktuellen Pelletspreis in Hamburg durch unseren umfassenden Vergleich. Geben Sie einfach Ihre Daten wie Postleitzahl sowie Abnahmemenge ein und erhalten Sie eine klare Übersicht der Preise von Hamburger Pellethändlern. Unser Preisvergleich zeigt Ihnen sofort, wo Sie in der Hansestadt am meisten sparen können.",
    howItWorksSecondary:
      "Die Preise für Pellets in Hamburg werden bei uns regelmäßig erfasst und aktualisiert, damit Sie jederzeit den Marktüberblick behalten. Nutzen Sie diese Transparenz für Ihren Vorteil und sichern Sie sich das beste Angebot. Mit unserem Vergleichsrechner wird der Pelletskauf in Hamburg einfach und kostenbewusst.",
    defaultZipcode: "20095",
  },
  hessen: {
    name: "Hessen",
    slug: "hessen",
    heroImage: require("~/assets/images/pellets/state/hessen.webp"),
    heroImageAlt: "Holzpellets Hessen",
    headline: "Aktuelle Pelletspreise für Hessen",
    howItWorksTitle: "Pelletspreis Hessen: Ihr Wegweiser zu fairen Preisen",
    howItWorksDescription:
      "Unser Pelletspreis-Vergleich für Hessen ermöglicht es Ihnen, mit minimalem Aufwand die günstigsten Anbieter zu finden. Tragen Sie Ihre Postleitzahl sowie die benötigte Menge und Sie erhalten sofort eine übersichtliche Darstellung der Preise in Hessen. So sichern Sie sich schnell und unkompliziert attraktive Konditionen beim Pelletkauf.",
    howItWorksSecondary:
      "Die hessischen Pelletpreise unterliegen Marktschwankungen, die wir kontinuierlich für Sie erfassen. Mit aktuellen Daten können Sie den richtigen Kaufzeitpunkt bestimmen und Ihr Budget optimal nutzen. Vertrauen Sie auf unseren Service und finden Sie problemlos einen passenden Lieferanten in Hessen.",
    defaultZipcode: "65183",
  },
  "mecklenburg-vorpommern": {
    name: "Mecklenburg-Vorpommern",
    slug: "mecklenburg-vorpommern",
    heroImage: require("~/assets/images/pellets/state/mecklenburg-vorpommern.webp"),
    heroImageAlt: "Holzpellets Mecklenburg-Vorpommern",
    headline: "Aktuelle Pelletspreise für Mecklenburg-Vorpommern",
    howItWorksTitle:
      "Pelletspreis Mecklenburg-Vorpommern: Regional vergleichen lohnt sich",
    howItWorksDescription:
      "Verschaffen Sie sich einen klaren Überblick über den Pelletspreis in Mecklenburg-Vorpommern. Unser Preisvergleich benötigt lediglich Ihre Postleitzahl sowie die gewünschte Bestellmenge und zeigt Ihnen anschließend die preiswertesten Angebote in Ihrer Region. Einfacher geht Geld sparen beim Pelletskauf nicht.",
    howItWorksSecondary:
      "In Mecklenburg-Vorpommern aktualisieren wir die Pelletpreise regelmäßig, sodass Sie immer auf dem neuesten Stand sind. Beobachten Sie die Preisentwicklung und schlagen Sie zum günstigsten Zeitpunkt zu. Mit unserem Vergleich finden Sie zuverlässige Lieferanten mit fairem Preis-Leistungs-Verhältnis.",
    defaultZipcode: "19053",
  },
  niedersachsen: {
    name: "Niedersachsen",
    heroImage: require("~/assets/images/pellets/state/niedersachsen.webp"),
    heroImageAlt: "Holzpellets Niedersachsen",
    slug: "niedersachsen",
    headline: "Aktuelle Pelletspreise für Niedersachsen",
    howItWorksTitle:
      "Pelletspreis Niedersachsen: Clever vergleichen und profitieren",
    howItWorksDescription:
      "Finden Sie den besten Pelletspreis in Niedersachsen mit unserem benutzerfreundlichen Preisvergleich. Nach Eingabe Ihrer Postleitzahl sowie der gewünschten Liefermenge präsentieren wir Ihnen die günstigsten regionalen Anbieter. So kommen Sie schnell und direkt zu einem fairen Angebot für Ihre Pelletheizung.",
    howItWorksSecondary:
      "Wir sorgen dafür, dass die Pelletpreise in Niedersachsen stets aktuell sind, damit Sie keine Gelegenheit für einen günstigen Einkauf verpassen. Nutzen Sie unseren Marktüberblick, um fundierte Entscheidungen zu treffen und beim Brennstoffkauf bares Geld zu sparen. Ihr Vorteil sind transparente Preise und verlässliche Lieferanten in Niedersachsen.",
    defaultZipcode: "30159",
  },
  "nordrhein-westfalen": {
    name: "Nordrhein-Westfalen",
    heroImage: require("~/assets/images/pellets/state/nordrhein-westfalen.webp"),
    heroImageAlt: "Holzpellets Nordrhein-Westfalen",
    slug: "nordrhein-westfalen",
    headline: "Aktuelle Pelletspreise für Nordrhein-Westfalen",
    howItWorksTitle:
      "Pelletspreis Nordrhein-Westfalen: Das große Vergleichsportal",
    howItWorksDescription:
      "Mit unserem Vergleichsrechner für den Pelletspreis in Nordrhein-Westfalen finden Sie mühelos die besten Angebote. Geben Sie Ihre Postleitzahl sowie Bestellmenge ein und wir liefern Ihnen eine transparente Übersicht der Preise von Pellethändlern in NRW. So sparen Sie Zeit und Geld beim Holzpelletskauf.",
    howItWorksSecondary:
      "Die Pelletpreise in Nordrhein-Westfalen werden von uns fortlaufend aktualisiert, damit Sie stets die aktuellen Marktbedingungen kennen. Planen Sie Ihren Einkauf strategisch und profitieren Sie von attraktiven Konditionen. Unser Service bringt Sie direkt zu den günstigsten und zuverlässigsten Lieferanten in NRW.",
    defaultZipcode: "40213",
  },
  "rheinland-pfalz": {
    name: "Rheinland-Pfalz",
    heroImage: require("~/assets/images/pellets/state/rheinland-pfalz.webp"),
    heroImageAlt: "Holzpellets Rheinland-Pfalz",
    slug: "rheinland-pfalz",
    headline: "Aktuelle Pelletspreise für Rheinland-Pfalz",
    howItWorksTitle:
      "Pelletspreis Rheinland-Pfalz: Ihr direkter Weg zum besten Angebot",
    howItWorksDescription:
      "Nutzen Sie unseren spezialisierten Pelletspreis-Vergleich für Rheinland-Pfalz und entdecken Sie attraktive Einkaufsoptionen. Mit wenigen Angaben zu Postleitzahl und Menge zeigen wir Ihnen die günstigsten Pellethändler in Ihrer Region. Transparenz und Einfachheit zeichnen unseren Service für Ihren Vorteil beim Pelletskauf aus.",
    howItWorksSecondary:
      "Wir aktualisieren die Pelletpreise in Rheinland-Pfalz regelmäßig, sodass Sie immer den aktuellen Markt im Blick haben. Finden Sie den idealen Zeitpunkt für Ihre Bestellung und sichern Sie sich faire Preise. Mit unserem Preisvergleich wird der Pelletskauf in Rheinland-Pfalz zum Kinderspiel.",
    defaultZipcode: "55116",
  },
  saarland: {
    name: "Saarland",
    heroImage: require("~/assets/images/pellets/state/saarland.webp"),
    heroImageAlt: "Holzpellets Saarland",
    slug: "saarland",
    headline: "Aktuelle Pelletspreise für Saarland",
    howItWorksTitle:
      "Pelletspreis Saarland: Klein aber fein im regionalen Vergleich",
    howItWorksDescription:
      "Im Saarland lohnt sich der Pellets-Preisvergleich. Unser Tool zeigt Ihnen schnell und übersichtlich die günstigsten Anbieter in Ihrer Nähe. Postleitzahl sowie gewünschte Menge eingeben und schon präsentieren wir Ihnen die besten verfügbaren Preise im Saarland. So sparen Sie beim Holzpelletskauf effektiv.",
    howItWorksSecondary:
      "Die Pelletpreise im Saarland halten wir kontinuierlich aktuell, damit Sie keine Preisänderung verpassen. Nutzen Sie diese Transparenz, um clever einzukaufen und von fairen Konditionen zu profitieren. Unser Vergleichsservice verbindet Sie mit verlässlichen Lieferanten im Saarland.",
    defaultZipcode: "66111",
  },
  sachsen: {
    name: "Sachsen",
    slug: "sachsen",
    heroImage: require("~/assets/images/pellets/state/sachsen.webp"),
    heroImageAlt: "Holzpellets Sachsen",
    headline: "Aktuelle Pelletspreise für Sachsen",
    howItWorksTitle:
      "Pelletspreis Sachsen: Der intelligente Preisvergleich für Sie",
    howItWorksDescription:
      "Finden Sie mit unserem Preisvergleich den günstigsten Pelletspreis in Sachsen. Durch die Eingabe von Postleitzahl und Bestellmenge erhalten Sie sofort eine übersichtliche Preisdarstellung sächsischer Pellethändler. Sparen Sie Zeit und Geld, indem Sie direkt das beste Angebot auswählen.",
    howItWorksSecondary:
      "In Sachsen erfassen wir die Pelletpreise regelmäßig, damit Sie stets aktuelle Informationen für Ihre Kaufentscheidung haben. Behalten Sie die Preisentwicklung im Auge und bestellen Sie zum optimalen Zeitpunkt. Unser Service hilft Ihnen, in Sachsen die besten Konditionen für Ihre Pelletheizung zu finden.",
    defaultZipcode: "01067",
  },
  "sachsen-anhalt": {
    name: "Sachsen-Anhalt",
    slug: "sachsen-anhalt",
    heroImage: require("~/assets/images/pellets/state/sachsen-anhalt.webp"),
    heroImageAlt: "Holzpellets Sachsen-Anhalt",
    headline: "Aktuelle Pelletspreise für Sachsen-Anhalt",
    howItWorksTitle:
      "Pelletspreis Sachsen-Anhalt: Transparent und aktuell vergleichen",
    howItWorksDescription:
      "Verschaffen Sie sich mit unserem Vergleichsrechner einen klaren Überblick über den Pelletspreis in Sachsen-Anhalt. Nennen Sie uns Ihre Postleitzahl sowie die gewünschte Liefermenge und wir zeigen Ihnen die preiswertesten Angebote in Ihrer Region. Einfach, schnell und zuverlässig zum besten Pelletskauf in Sachsen-Anhalt.",
    howItWorksSecondary:
      "Wir halten die Pelletpreise für Sachsen-Anhalt stets auf dem neuesten Stand, damit Sie von aktuellen Marktbedingungen profitieren können. Planen Sie Ihren Einkauf strategisch und sparen Sie beim Holzpelletskauf. Unser Service verbindet Sie mit fairen Lieferanten in Sachsen-Anhalt.",
    defaultZipcode: "39104",
  },
  "schleswig-holstein": {
    name: "Schleswig-Holstein",
    heroImage: require("~/assets/images/pellets/state/schleswig-holstein.webp"),
    heroImageAlt: "Holzpellets Schleswig-Holstein",
    slug: "schleswig-holstein",
    headline: "Aktuelle Pelletspreise für Schleswig-Holstein",
    howItWorksTitle:
      "Pelletspreis Schleswig-Holstein: Ihr Nordlicht beim Preisvergleich",
    howItWorksDescription:
      "Entdecken Sie den besten Pelletspreis in Schleswig-Holstein mit unserem effizienten Preisvergleich. Geben Sie Ihre Postleitzahl sowie die benötigte Menge und Sie erhalten eine transparente Übersicht der günstigsten Anbieter im echten Norden. So finden Sie mühelos das günstigste Angebot.",
    howItWorksSecondary:
      "Die Pelletpreise in Schleswig-Holstein werden bei uns kontinuierlich aktualisiert, sodass Sie immer den aktuellen Markt kennen. Nutzen Sie diese Information, um clever zu kaufen und bares Geld zu sparen. Mit unserem Vergleich finden Sie zuverlässige Lieferanten mit fairen Konditionen in Schleswig-Holstein.",
    defaultZipcode: "24103",
  },
  thueringen: {
    name: "Thüringen",
    heroImage: require("~/assets/images/pellets/state/thueringen.webp"),
    heroImageAlt: "Holzpellets Thüringen",
    slug: "thueringen",
    headline: "Aktuelle Pelletspreise für Thüringen",
    howItWorksTitle: "Pelletspreis Thüringen: Ihr regionaler Preiskompass",
    howItWorksDescription:
      "Mit unserem Pelletspreis-Vergleich für Thüringen finden Sie spielend leicht die günstigsten Angebote in Ihrer Region. Postleitzahl sowie Abnahmemenge eingeben und schon zeigen wir Ihnen die attraktivsten Preise von Thüringer Pellethändlern. Clever vergleichen und beim Heizmaterialkauf kräftig sparen!",
    howItWorksSecondary:
      "Wir aktualisieren die Pelletpreise in Thüringen regelmäßig, damit Sie stets informiert sind und den optimalen Kaufzeitpunkt nicht verpassen. Nutzen Sie unseren Service für transparente Preise und faire Angebote. Finden Sie mit wenigen Klicks einen passenden Lieferanten in Thüringen.",
    defaultZipcode: "99084",
  },
};

export default pelletsStateContent;
